import dedent from 'ts-dedent'
import { DataWarehouseConnection } from '../workflow/connections'

export function createTableWithBBox(
  connection: DataWarehouseConnection,
  sourceTable: string,
  outputTable: string,
  geoColumn: string,
  toGeomFunction: (column: string) => string
): string {
  const query = dedent`
        spark.sql(f'''
            CREATE TABLE IF NOT EXISTS ${connection.quoteName(outputTable)}
            AS
            (
              SELECT /*+ REPARTITION(40, ${geoColumn}) */
                  *,
                  ROW_NUMBER() OVER(ORDER BY ${geoColumn}) AS __carto_id,
                  ST_XMIN(${toGeomFunction(geoColumn)}) AS xmin,
                  ST_YMIN(${toGeomFunction(geoColumn)}) AS ymin,
                  ST_XMAX(${toGeomFunction(geoColumn)}) AS xmax,
                  ST_YMAX(${toGeomFunction(geoColumn)}) AS ymax
              FROM
                  ${connection.quoteName(sourceTable as string)}
            )
            CLUSTER BY (xmin, ymin, xmax, ymax)
            '''
        )
        `
  return query
}

export function getSetClusterParamsQuery(connection: DataWarehouseConnection, tables: string[]) {
  return dedent`
        bin_size = spark.sql(f'''
            SELECT ROUND(MAX(v), 2) AS v
            FROM (
              ${tables
                .map(
                  (table) => `SELECT EXPLODE(APPROX_PERCENTILE(CAST(xmax - xmin AS DOUBLE), ARRAY(0.95), 1000000)) AS v
              FROM ${connection.quoteName(table)}
              UNION
              SELECT EXPLODE(APPROX_PERCENTILE(CAST(ymax - ymin AS DOUBLE), ARRAY(0.95), 1000000)) AS v
              FROM ${connection.quoteName(table)}`
                )
                .join('\nUNION\n')}
            )''').collect()[0]['v']
        spark.conf.set("spark.databricks.optimizer.rangeJoin.binSize", f"{bin_size}")
        `
}
